import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import ShiftPatternAddForm from 'components/organismos/master/labor/shiftPattern/ShiftPatternAddForm';

const ShiftPatternAddPage: React.FC = () => {
  return (
    <SidebarTemplate >
      <ShiftPatternAddForm />
    </SidebarTemplate>
  );
};

export default ShiftPatternAddPage;
